var TSATC = {
    zipcodeRequired: false,
    zipcodeValidate: function(zipcode, productID) {
        let zipcodes = $('[data-product-id=' + productID + ']').attr('data-product-zipcodes').split(',');

        return zipcodes.includes(zipcode);
    },
    zipcodeGetCookie: function() {
        let cookie = cookieGet('fec_zcg');
        return cookie ? cookieDecode(cookie) : {
            c: null
        };
    },
    zipcodeUpdateCookie: function(zipcode, productID, productHandle) {
        let currentCookie = this.zipcodeGetCookie();
        let expires = fec_zcg_life || 60;

        let newCookie = {
            c: zipcode,
            i: productID,
            h: productHandle,
            n: currentCookie.n++,
            z: Math.round(new Date().getTime() / 1000),
        }

        cookieSet('fec_zcg', cookieEncode(newCookie), expires);
    },
    zipcodeLastChecked: null,
    ageCheckRequired: false,
    agecheckGetCookie: function() {
        let cookie = cookieGet('fec_ag');
        return cookie ? cookieDecode(cookie) : {
            c: undefined
        };
    },
    agecheckUpdateCookie: function(agecheck, productID, productHandle) {
        let currentCookie = this.agecheckGetCookie();
        let expires = fec_ag_life || 60;

        let newCookie = {
            c: agecheck,
            i: productID,
            h: productHandle,
            n: currentCookie.n++,
            z: Math.round(new Date().getTime() / 1000),
        }

        cookieSet('fec_ag', cookieEncode(newCookie), expires);
    },
    checkOptionsEnabled: function() {
        return !this.zipcodeRequired && !this.ageCheckRequired;
    }
}

$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
}

// Shopify's JSON /cart/add.js endpoint requires a nested `properties` object;
// serializeObject() leaves bracket-notation keys (e.g. "properties[Preorder]")
// flat, so they get silently dropped unless converted here.
function nestPropertiesKeys(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) {
            acc.properties = acc.properties || {};
            acc.properties[match[1]] = value;
        } else {
            acc[key] = value;
        }
        return acc;
    }, {});
}

function bsr_response_handler() {
    const res = JSON.parse(this.responseText);
    for (const [key, value] of Object.entries(res)) {
        const parsed = new DOMParser().parseFromString(value, 'text/html');
        const source = parsed.getElementById('shopify-section-' + key);
        const target = document.getElementById('shopify-section-' + key);
        if (!source || !target) continue;
        const innerHTML = source.innerHTML;
        target.innerHTML = innerHTML;
        try {
            runScripts(document.getElementById('shopify-section-' + key));
        } catch (e) {
            console.warn('TS CTA - Unable to call `runScripts()`', e);
        }
    }
}

function bsr(bsr_sections) {
    const request = new XMLHttpRequest();
    request.addEventListener('load', bsr_response_handler);
    request.open('GET', window.location.pathname + '?sections=' + bsr_sections, true);
    request.send();
}
// jquery on document ready
$(function() {
    // We need to target the container instead of the cards due to lazy-loading interferring with event capture
    let $productCardContainer = $(document.body);

    let product = '.tsatc-product-item';
    let formProduct = '.tsatc-form';
    let buttonQuickAdd = '.tsatc-button--quickadd';
    let buttonAvailable = '.tsatc-button--add-to-cart';
    let buttonZipcodeCheck = '.tsatc-zipcode-delivery--button';

    // Membership terms & conditions gate — require acceptance before letting a
    // gated .tsatc-form submit through to the add-to-cart fetch below.
    let tsatcOpenTermsModal = function($form) {
        let modalSelector = $form.data('requires-terms-modal');
        if (!modalSelector) return false;

        let $modal = $(modalSelector);
        if (!$modal.length) return false;

        $modal.data('pending-form', $form);
        $modal.removeAttr('hidden').addClass('membership-terms-modal--open');
        $('body').addClass('membership-terms-modal-open');
        return true;
    }

    let tsatcCloseTermsModal = function($modal) {
        $modal.attr('hidden', true).removeClass('membership-terms-modal--open').removeData('pending-form');
        $('body').removeClass('membership-terms-modal-open');
    }

    $(document.body).on('click', '[data-membership-terms-accept]', function(e) {
        e.preventDefault();
        let $modal = $(this).closest('[data-membership-terms-modal]');
        let $form = $modal.data('pending-form');

        tsatcCloseTermsModal($modal);

        if ($form && $form.length) {
            $form.data('terms-accepted', true);
            $form.trigger('submit');
        }
    })

    $(document.body).on('click', '[data-membership-terms-dismiss]', function(e) {
        e.preventDefault();
        tsatcCloseTermsModal($(this).closest('[data-membership-terms-modal]'));
    })

    $(document).on('keydown', function(e) {
        if (e.key !== 'Escape') return;
        $('[data-membership-terms-modal].membership-terms-modal--open').each(function() {
            tsatcCloseTermsModal($(this));
        });
    })

    let disableOptions = function($currentCard, $currentButton) {
        $currentCard.addClass('tsatc-disable-options');
        $currentButton.attr('disabled', true).removeClass('tsatc-button--long-text');

        let buttonDisabledText = [];
        if (TSATC.zipcodeRequired) buttonDisabledText.push('Check Zip');
        if (TSATC.ageCheckRequired) buttonDisabledText.push('Confirm Age');
        if (buttonDisabledText.length > 1) $currentButton.addClass('tsatc-button--long-text');

        $currentButton.find('.tsatc-button--text').text(buttonDisabledText.join(' & '));
    }

    let enableOptions = function($currentCard, $currentButton) {
        $currentCard.removeClass('tsatc-disable-options');
        $currentButton.removeAttr('disabled').removeClass('tsatc-button--long-text');
        $currentButton.find('.tsatc-button--text').text($currentButton.data('title'));
    }

    // Show options on hovering or clicking (mobile) the product card button
    $productCardContainer.on('click mouseenter', buttonQuickAdd, function(e) {
        let $this = $currentButton = $(this);
        let $currentOptions = $this.prev('.tsatc-card-options');

        // If button is ready for adding to cart, don't do anything (see #92) to allow submit on Safari (see #167)
        if ($currentButton.attr('type') == 'submit' && $currentOptions.hasClass('tsatc-card-options--show')) return;

        let $zipcodeField = $currentOptions.find('[name="zipcode-delivery-field"]');
        let $ageField = $currentOptions.find('[name="age-check-field"]');

        // Hide all visible cards
        $('.tsatc-card-options--show').removeClass('.tsatc-card-options--show');


        // Show the card for only the clicked button
        $currentOptions.addClass('tsatc-card-options--show');

        // Sync button price with the currently selected options (e.g. subscription is
        // pre-checked by default, but the button price is server-rendered as one-time)
        $this.closest(formProduct).trigger('change');
        // Check if $button has class 'pdp-stickycta--button' and change it
        if ($this.hasClass('pdp-stickycta--button')) {
            $this.removeClass('pdp-stickycta--button').addClass('pdp-stickycta--add');
        }

        // Button disabled text
        TSATC.zipcodeRequired = false;
        TSATC.ageCheckRequired = false;

        // If zipcode field exist, auto-populate zipcode from cookie and auto-check it
        if ($zipcodeField.length) {
            if (TSATC.zipcodeLastChecked === null) TSATC.zipcodeRequired = true;

            // Fill value with cookie value
            let cookie = TSATC.zipcodeGetCookie().c || '';
            $zipcodeField.val(cookie);

            // Enable the zipcode field and focus it
            // This is to get around a bug in Flickity where focusing the input scrolls the slider up
            requestAnimationFrame(function() {
                $zipcodeField.removeAttr('disabled')[0].focus({
                    preventScroll: true
                }); // modern browsers
                // See end of file for Safari hack
            });

            // If cookie, auto-check zipcode
            if (cookie) $currentOptions.find('.tsatc-zipcode-delivery--button').trigger('click');
        }

        // If age field exists, auto-populate age from cookie
        if ($ageField.length) {
            let cookie = TSATC.agecheckGetCookie().c || '';

            if (cookie !== 'y') {
                TSATC.ageCheckRequired = true;
                $ageField.prop('checked', false);
            } else {
                TSATC.ageCheckRequired = false;
                $ageField.prop('checked', true);
            }
        }

        if (TSATC.checkOptionsEnabled()) {
            enableOptions($currentOptions, $currentButton);
        } else {
            let buttonDisabledText = [];
            if (TSATC.zipcodeRequired) buttonDisabledText.push('Check Zip');
            if (TSATC.ageCheckRequired) buttonDisabledText.push('Confirm Age');

            disableOptions($currentOptions, $currentButton, buttonDisabledText.join(' & '));
        }

        // Enable fields after a delay or else the initial click will trigger the submit button
        setTimeout(function() {
            $zipcodeField.removeAttr('disabled');
            $ageField.removeAttr('disabled');
            $currentButton.attr('type', 'submit');
        }, 500);
    })

    // Hide options on leaving the product card
    $productCardContainer.on('mouseleave', formProduct, function(e) {
        let $this = $(this);
        let $currentButton = $this.find(buttonQuickAdd);

        // Prevents bug in Firefox which fires mouseleave event when mouse is over a select element
        if (!e.relatedTarget) return;

        // Hide card
        $this.find('.tsatc-card-options').removeClass('tsatc-card-options--show');

        // Check if $button has class 'pdp-stickycta--add' and change it
        if ($currentButton.hasClass('pdp-stickycta--add')) {
            $currentButton.removeClass('pdp-stickycta--add').addClass('pdp-stickycta--button');
        }

        // Reset button
        $currentButton.attr('type', 'button').removeAttr('disabled').removeClass('tsatc-button--long-text');
        $currentButton.find('.tsatc-button--text').text($currentButton.data('title'));
        $this.find('[name="age-check-field"]').attr('disabled', true);
        $this.find('[name="zipcode-delivery-field"]').attr('disabled', true);
    })

// Intercept form submission and post via ajax
$productCardContainer.on('submit', formProduct, function(e) {
    e.preventDefault();

    let $this = $(this);

    if ($this.data('requires-terms-modal') && !$this.data('terms-accepted')) {
        tsatcOpenTermsModal($this);
        return;
    }

    let $button = $this.find('.tsatc-button');
    let $optionsFlyout = $this.find('.tsatc-card-options');
    let $pumpInput = $this.find('[name="addonpump"]');
    let $boxInput = $this.find('[name="addonbox"]');
    let membershipUpsellInput = $this.find('[data-name="membershipUpsell"]');
    let membershipUpsellID = membershipUpsellInput.data("upsell-product-id");
    let membershipUpsellSellingPlan = membershipUpsellInput.data("upsell-selling-plan");
    let isOneTime = $this.find('[value="onetime"], [value="onetime_upsell"], [value="onetime_upsell_no_sub"]').is(':checked');

    // Data sent to Shopify API
    let formData = isOneTime ? {
        items: [nestPropertiesKeys($this.find('[name]').not('.tsatc-sub-options').not('.tsatc-exclude').serializeObject())]
    } : {
        items: [nestPropertiesKeys($this.not('.tsatc-exclude').serializeObject())]
    };

    if ($pumpInput.length && $pumpInput.is(':checked')) {
        formData.items.unshift({
            id: $pumpInput.val(),
            quantity: $pumpInput.data('addon-qty'),
            properties: {
                _subscriptionOption: ""
            }
        })
    }

    if ($boxInput.length && $boxInput.is(':checked')) {
        formData.items.unshift({
            id: $boxInput.val(),
            quantity: $boxInput.data('addon-qty'),
            properties: {
                _subscriptionOption: ""
            }
        })
    }

    if (membershipUpsellInput.length && membershipUpsellInput.is(':checked')) {
        let membershipCartItem = { id: membershipUpsellID, quantity: 1 };
        if (membershipUpsellSellingPlan) membershipCartItem.selling_plan = membershipUpsellSellingPlan;
        formData.items.unshift(membershipCartItem);
    }

    $button.find('.tsatc-button--text').text('Adding...');
    
    // Post product to Shopify
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response) return {};
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(r => {
        // Reset buttons
        $button.find('.tsatc-button--text').text($button.data('title'));
        $button.attr('disabled', false);
        try { document.dispatchEvent(new CustomEvent('tsatc:add-to-cart-end')); } catch(e) { console.warn('tsatc:add-to-cart-end handler error:', e); }

        // Hide card
        $optionsFlyout.removeClass('.tsatc-card-options--show');
        
        // Check if $button has class 'pdp-stickycta--add' and change it
        if ($button.hasClass('pdp-stickycta--add')) {
            $button.removeClass('pdp-stickycta--add').addClass('pdp-stickycta--button');
        }

        // Rebuy's onsite script auto-detects the /cart/add.js call and opens SmartCart itself.

        // if member or membership in cart, disable all TS ATC buttons for membership product on page
        if ($button.data('tsatc-membership')) {
            $('[data-tsatc-membership]').each(function() {
                $(this).find('.tsatc-button--text').text('YOU\'RE A MEMBER!');
                $(this).prop('disabled', true);
            });
        }

        // if member + adding free gift, disable button
        if ($button.data('tsatc-mqg')) {
            $button.find('.tsatc-button--text').text('GIFT REDEEMED');
            $button.prop('disabled', true);
            $button.find('.tsatc-button--price').html('<span class="tsatc-button--price-base">' + $button.find('.tsatc-button--price-compare-at').text() + '</span>');
        }

        // if is membership popup add-to-cart button
        if ($button.closest('.tsatc-product-item').hasClass('close-pdp-membership-popup')) {
            try {
                pdp_membership_popup_close();
            } catch (e) {
                console.warn('Unable to close PDP membership popup.', e);
            }

            // render new product page sections
            var bsr_sections = false;
            if (jQuery('.pdp-container').length > 0) {
                bsr_sections = 'product-template,product-content';
            } else if (jQuery('.collection-candles').length > 0) {
                bsr_sections = 'lp-candles-featured,lp-candles-featured-r2';
            }
            
            if (bsr_sections) {
                fetch(window.location.pathname + '?sections=' + bsr_sections)
                    .then(response => response.json())
                    .then(res => {
                        for (const [key, value] of Object.entries(res)) {
                            const innerHTML = new DOMParser()
                                .parseFromString(value, 'text/html')
                                .getElementById('shopify-section-' + key).innerHTML;
                            document.getElementById('shopify-section-' + key).innerHTML = innerHTML;
                            try {
                                runScripts(document.getElementById('shopify-section-' + key));
                            } catch (e) {
                                console.warn('TS CTA - Unable to call runScripts()', e);
                            }
                        }
                    })
                    .catch(e => {
                        console.warn('Error loading sections:', e);
                    });
            }
        }

        // add to cart source attribution line item properties - change all values for this product
        var mainItem = r.items && r.items.find(function(item) {
            return item.properties && item.properties['_atc_source_type'];
        });
        if (mainItem) {
            var product_id = mainItem.product_id;
            var new_source_type = mainItem.properties['_atc_source_type'];
            var new_source_value = mainItem.properties['_atc_source_value'];
            var new_source_placement = mainItem.properties['_atc_source_placement'];
            console.log('Setting ATC source line item properties for product ID: ' + product_id, {
                new_source_type: new_source_type,
                new_source_value: new_source_value,
                new_source_placement: new_source_placement
            });
            $('.product-id-' + product_id + '[name="properties[_atc_source_type]"]').val(new_source_type);
            $('.product-id-' + product_id + '[name="properties[_atc_source_value]"]').val(new_source_value);
            $('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]').val(new_source_placement);
            $('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]').addClass('revised');
        }
    })
    .catch(error => {
        if (error instanceof TypeError) {
            $button.find('.tsatc-button--text').text($button.data('title'));
            $button.attr('disabled', false);
            return;
        }
        console.error('Add to cart error:', error);
        $button.find('.tsatc-button--text').text('Error. Please try again');
        setTimeout(function() {
            $button.find('.tsatc-button--text').text($button.data('title'));
            document.dispatchEvent(new CustomEvent('tsatc:add-to-cart-end'));
        }, 3000);
    });
})

    // Update form details when choosing different options in options flyout
    $productCardContainer.on('change', formProduct, function(e) {
        e.preventDefault();
        let $this = $(this);

        // get product JSON data
        const productData = $(e.currentTarget).data('product-data');
        const sitewideSaleFactor = parseFloat($(e.currentTarget).data('sitewidesale-factor'));

        // Forms without a parsed product-data payload (e.g. dynamically-injected
        // widget markup) can't be synced — bail instead of throwing.
        if (!productData || !productData.variants) {
            return;
        }

        // Get the variant ID for the selected product
        let $currentVariant = $this.find('[name="variant"]:checked');
        let newVariantID = $currentVariant.val() || $this.find('.tsatc-default-variant').attr('data-original-value');
        let $subscriptionLineItem = $this.find('[data-subscriptionoptionvariantid]');

        // get current variant data from newVariantID
        let currentVariantData = productData.variants.find(function(variant) {
            return variant.id === parseInt(newVariantID)
        });

        // Get the subscription ID for the selected product
        let $currentSubscription = $this.find('[name="selling_plan"]');
        let newSubscriptionID = $currentSubscription.val();
        let variantSubscriptionMap = $currentVariant.attr('data-variant-subscription-price-map');

        // get pricing information
        let productPrice = currentVariantData.price;
        let compareAtPrice = currentVariantData.compare_at_price;
        let subscriptionPrice = false;
        let sellingPlan = false;
        if ($currentSubscription.val()) {
            sellingPlan = currentVariantData.selling_plan_allocations.find(function(selling_plan) {
                return selling_plan.selling_plan_id === parseInt($currentSubscription.val())
            })
            subscriptionPrice = sellingPlan ? sellingPlan.price : false;
        }

        // override prices if sitewide sale
        if (sitewideSaleFactor !== 1) {
            if (compareAtPrice) {
                productPrice = currentVariantData.compare_at_price * sitewideSaleFactor;
                subscriptionPrice = currentVariantData.compare_at_price * sitewideSaleFactor;
                compareAtPrice = currentVariantData.compare_at_price;
            } else {
                productPrice = currentVariantData.price * sitewideSaleFactor;
                subscriptionPrice = currentVariantData.price * sitewideSaleFactor;
                compareAtPrice = currentVariantData.price;
            }
        }

        // adjust price if recyclable pump added
        let $pumpInput = $this.find('input.add-recyclable-pump');
        let $boxInput = $this.find('input.add-gift-box');
        let $memberUpsellInput = $this.find('input.add-membership');
        let pumpPriceAdjustment = $pumpInput.is(':checked') ? $pumpInput.data('price-adjustment') : 0;
        let boxPriceAdjustment = $boxInput.is(':checked') ? $boxInput.data('price-adjustment') : 0;
        let memberUpsellAdjustmentPrice = $memberUpsellInput.data('price-adjustment');
        console.log(memberUpsellAdjustmentPrice);
        function addPriceAdjustments(originalPrice) {
            if ($memberUpsellInput.is(':checked')) {
                return Shopify.formatMoney((originalPrice + pumpPriceAdjustment + boxPriceAdjustment) * memberUpsellAdjustmentPrice).replace('.00', '');
            }
            else {
                return Shopify.formatMoney(originalPrice + pumpPriceAdjustment + boxPriceAdjustment).replace('.00', '');
            }
        }

        // Update one-time price based on current variant
        if ($this.find('.tsatc-variants').length) {
            let variantPrice = $this.find('[value=' + newVariantID + ']').attr('data-variant-price');
            let memberPrice = variantPrice * memberUpsellAdjustmentPrice;
            if (variantPrice) {
                $this.find('.tsatc-price').text(Shopify.formatMoney(variantPrice).replace('.00', ''));
                $this.find('.member-price').text(Shopify.formatMoney(memberPrice).replace('.00', ''));
            }
        }

        // Update subscription price based on current variant
        if (newSubscriptionID && variantSubscriptionMap) {
            let IDMapping = JSON.parse(variantSubscriptionMap);
            let variantSubscriptionPrice = IDMapping[newSubscriptionID].price || $this.find('[data-subscription-price]').attr('data-subscription-price');

            if (variantSubscriptionPrice) {
                $this.find('[data-subscription-price]').text(Shopify.formatMoney(variantSubscriptionPrice).replace('.00', ''));
            }
        }

        // Update the add-to-cart button price
        const $priceBase = $this.find('.tsatc-button--price-base');

        if (compareAtPrice) {
            $this.find('.tsatc-button--price-compare-at').text(addPriceAdjustments(compareAtPrice))
            $priceBase.text(addPriceAdjustments(productPrice))
        }

        if ($this.find('[name="has_subscription"]').length) {
            $this.find('[value="subsave"]:checked').length ?
                $priceBase.text(addPriceAdjustments(subscriptionPrice)) :
                $priceBase.text(addPriceAdjustments(productPrice));
        } else {
            $priceBase.text(addPriceAdjustments(productPrice))
        }

        // Update the variant ID input with the currently selected variant
        $this.find('.tsatc-default-variant').val(newVariantID);
        if ($subscriptionLineItem.length) $subscriptionLineItem.attr('data-subscriptionoptionvariantid', newVariantID);

        // If age field exists, update cookie
        let $ageField = $this.find('[name="age-check-field"]');

        if ($ageField.length) {
            TSATC.ageCheckRequired = true;

            let val = $ageField.is(':checked') ? 'y' : 'n';
            if (val === 'y') TSATC.ageCheckRequired = false;
            let productID = $ageField.attr('data-product-id');
            let productHandle = $ageField.attr('data-product-handle');

            TSATC.agecheckUpdateCookie(val, productID, productHandle);
        }

        let $currentOptions = $this.find('.tsatc-card-options');
        let $currentButton = $this.find(buttonQuickAdd);

        // Enable or disable options
        if (TSATC.checkOptionsEnabled()) {
            enableOptions($currentOptions, $currentButton);
        } else {
            disableOptions($currentOptions, $currentButton);
        }
    })

    // In stock products, attach Klaviyo add-to-cart event
    $productCardContainer.on('click', buttonAvailable, function() {
      let productInfo = JSON.parse($(this).next('.klaviyo-product-data').text());
      window._learnq = _learnq || [];
      window._learnq.push(['track', 'Added to Cart', productInfo]);
    })
  
    // Check zipcode when clicking the zipcode check button
    $productCardContainer.on('click', buttonZipcodeCheck, function(e) {
        let $this = $(this);
        let $zipcodeOptions = $this.closest('.tsatc-zipcode-delivery');
        let $zipCodeField = $zipcodeOptions.find('.tsatc-zipcode-delivery--input');
        let $zipCodeMessage = $zipcodeOptions.find('.tsatc-zipcode-delivery--message');

        let $currentOptions = $this.closest('.tsatc-card-options');
        let $currentButton = $currentOptions.next(buttonQuickAdd);

        let currentZip = $zipCodeField.val();
        let productID = $zipCodeField.attr('data-product-id');
        let isZipcodeValid = currentZip && $zipCodeField[0].validity.valid;

        // Update last checked zipcode
        TSATC.zipcodeLastChecked = currentZip;

        // If value entered isn't a valid zip code
        if (!isZipcodeValid) {
            TSATC.zipcodeRequired = true;

            if (currentZip) $zipCodeMessage.text('Please enter a 5-digit US zipcode');
            $zipCodeField.val('');

            disableOptions($currentOptions, $currentButton);

            return;
        }

        // If zipcode is a valid delivery area, enable submit button
        if (TSATC.zipcodeValidate(currentZip, productID)) {
            TSATC.zipcodeRequired = false;
            var msghtml = jQuery.parseHTML(`<div>` + $zipCodeMessage.data('msg-pass') + `</div>`);
            jQuery(msghtml).find('[data-zipcode-val]').replaceWith(currentZip);
            // console.log( `~~ pass`, jQuery(msghtml).html() );
            $zipCodeMessage.html(jQuery(msghtml).html());
        } else {
            TSATC.zipcodeRequired = true;
            var msghtml = jQuery.parseHTML(`<div>` + $zipCodeMessage.data('msg-fail') + `</div>`);
            jQuery(msghtml).find('[data-zipcode-val]').replaceWith(currentZip);
            // console.log( `~~ fail`, jQuery(msghtml).html() );
            $zipCodeMessage.html(jQuery(msghtml).html());
        }

        // Enable or disable options
        if (TSATC.checkOptionsEnabled()) {
            enableOptions($currentOptions, $currentButton);
        } else {
            disableOptions($currentOptions, $currentButton);
        }

        // Update cookie
        TSATC.zipcodeUpdateCookie(currentZip, productID, $zipCodeField.attr('data-product-handle'));
    })

    // Safari input focus hack
    $productCardContainer.on('focus', '.tsatc-zipcode-delivery--input', function() {
        let $carouselViewport = $(this).closest('.flickity-viewport').scrollTop(0);

        setTimeout(function() {
            $carouselViewport.scrollTop(0);
        }, 50);
    })

    // Sync add-to-cart button prices with default-checked options (e.g. subscription
    // pre-checked as default) on page load, since the button price is server-rendered
    // as one-time regardless of the default selection
    $(formProduct).trigger('change');
})